"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fmko_ts_common_1 = require("fmko-ts-common");
const HasValueWidget_1 = tslib_1.__importDefault(require("../../widget/HasValueWidget"));
const LabelLocation_1 = require("../../fields/LabelLocation");
// Component rendered in the user interface
// <div class="switch-container">
//   <div class="switch">
//     <input id="switch-id" type="checkbox" class="switch-input">
//     <span aria-controls="checkbox-id" aria-checked="false" class="switch-label" tabindex="0" role="switch"></span>
//   </div>
//   <label for="switch-id" class="switch-text-label">Switch på venstre side af label</label>
// </div>
/**
 * @deprecated use {@link WCAGSwitch} instead
 */
class Switch extends HasValueWidget_1.default {
    constructor(label, labelLocation = LabelLocation_1.LabelLocation.RIGHT) {
        super();
        this.label = label;
        this.element = document.createElement("div");
        this.element.classList.add("switch-container");
        const switchElement = document.createElement("div");
        switchElement.classList.add("switch");
        this.input = document.createElement("input");
        this.input.type = "checkbox";
        this.input.classList.add("switch-input");
        const inputId = fmko_ts_common_1.GlobalCounter.next();
        this.input.id = inputId;
        this.input.addEventListener("click", event => {
            const target = event.target;
            this.setValue(target.checked, true);
        });
        this.switchSpan = document.createElement("span");
        this.switchSpan.setAttribute(fmko_ts_common_1.ARIA.CONTROLS, inputId);
        this.switchSpan.setAttribute(fmko_ts_common_1.ARIA.CHECKED, "false");
        this.switchSpan.setAttribute(fmko_ts_common_1.ARIA.LABEL, label);
        this.switchSpan.classList.add("switch-label");
        this.switchSpan.tabIndex = 0;
        fmko_ts_common_1.WCAG.addButtonEvent({
            ariaRole: fmko_ts_common_1.ARIARole.SWITCH,
            callback: () => {
                this.input.click();
            },
            element: this.switchSpan
        });
        this.switchSpan.addEventListener("keyup", event => {
            if (event.key === "Tab") {
                this.switchSpan.classList.add("switch-label-tab-focused");
            }
        });
        this.switchSpan.addEventListener("blur", () => {
            this.switchSpan.classList.remove("switch-label-tab-focused");
        });
        this.labelElement = document.createElement("label");
        this.labelElement.htmlFor = inputId;
        this.labelElement.textContent = label;
        this.labelElement.classList.add("switch-text-label");
        switchElement.appendChild(this.input);
        switchElement.appendChild(this.switchSpan);
        if (labelLocation === LabelLocation_1.LabelLocation.RIGHT) {
            this.element.appendChild(switchElement);
            this.element.appendChild(this.labelElement);
        }
        else if (labelLocation === LabelLocation_1.LabelLocation.LEFT) {
            this.labelElement.classList.add("switch-text-label-left");
            this.element.appendChild(this.labelElement);
            this.element.appendChild(switchElement);
        }
    }
    getValue() {
        return this.value;
    }
    getLabel() {
        return this.label;
    }
    setLabel(label) {
        this.label = label;
        this.labelElement.textContent = this.label;
    }
    setValue(value, fireEvent) {
        this.value = value;
        this.input.checked = value;
        this.switchSpan.setAttribute(fmko_ts_common_1.ARIA.CHECKED, `${value}`);
        if (fireEvent) {
            this.fireEvent(new fmko_ts_common_1.ValueChangeEvent(value));
        }
    }
    isEnabled() {
        return !this.input.hasAttribute("disabled");
    }
    setEnabled(enabled) {
        this.input.toggleAttribute("disabled", !enabled);
        this.element.toggleAttribute("disabled", !enabled);
    }
}
exports.default = Switch;
//# sourceMappingURL=Switch.js.map